module.exports = __webpack_public_path__ + "static/media/knob.d1074628.png";